export default __webpack_public_path__ + "static/media/correct2.59e9b288.mp3";